export default __webpack_public_path__ + "static/media/History.bb8374fc.svg";